// Стойностите на реда, които BE-то не връща като собствено поле, а се смятат
// от вложените поръчки. Отговорът носи целия граф на страницата, така че това
// е обхождане на 20 сметки, не заявка.
//
// Същите числа BE-то смята и за целия период (`totals`), по същите правила —
// затова редът „Общо" се връзва със сбора на видимите редове.

import type { BillHistory, BillHistoryOrder } from "../../../../api/reportsBillsHistory";
import { parseDecimal } from "../../../../components/dataTable";

/**
 * Копието-следа от разделяне (`is_split` БЕЗ `split_from_bill_id`) остава в
 * ОРИГИНАЛНАТА сметка, а същите редове живеят и в новата. Всяко сумиране —
 * пари или количества — трябва да го изключи, иначе разделената част се брои
 * два пъти (виж NOT_SPLIT_TRACE в bills/models.py на бекенда).
 */
const isSplitTrace = (order: BillHistoryOrder) =>
  order.is_split && order.split_from_bill_id === null;

/** Сборът на количествата на НЕсторнираните редове. */
export const itemsQuantityOf = (bill: BillHistory): number => {
  let quantity = 0;
  for (const order of bill.orders ?? []) {
    if (isSplitTrace(order)) continue;
    for (const item of order.items) {
      if (item.is_cancelled) continue;
      quantity += parseDecimal(item.quantity);
    }
  }
  return quantity;
};

/** Сторнираната сума — редовете плюс добавките им. */
export const cancelledTotalOf = (bill: BillHistory): number => {
  let total = 0;
  for (const order of bill.orders ?? []) {
    if (isSplitTrace(order)) continue;
    for (const item of order.items) {
      if (!item.is_cancelled) continue;
      total += parseDecimal(item.total_sum);
      for (const addition of item.additions ?? []) {
        total += parseDecimal(addition.total_sum);
      }
    }
  }
  return total;
};

/** Броят СТОРНИРАНИ редове — същият обхват като парите (без следата). */
export const cancelledCountOf = (bill: BillHistory): number => {
  let count = 0;
  for (const order of bill.orders ?? []) {
    if (isSplitTrace(order)) continue;
    for (const item of order.items) {
      if (item.is_cancelled) count += 1;
    }
  }
  return count;
};

/** Отстъпката, както я е записало BE-то. Изведена („бруто − сума") би броила
 *  и редовете със СМЕНЕНА ЦЕНА за отстъпка. */
export const discountOf = (bill: BillHistory): number =>
  parseDecimal(bill.total_discount ?? "0");

/** Фискализирана = има номер на бон. `total` е 0 при нефискализирана, затова
 *  той НЕ е критерият — виж коментара при `receipt_number` в api модула. */
export const isFiscalized = (bill: BillHistory): boolean =>
  Boolean(bill.receipt_number);
